import {action, makeObservable, observable} from "mobx";
import {TimeSpan} from "@sparkware/app-utils";

export class VideoWatchTimeHandler {
    constructor() {
        this._watchStartTime = 0
        this._watchTimeMilliseconds = 0;
        makeObservable(this);
    }

    private _watchStartTime: number = 0;

    @observable.ref
    private _watchTimeMilliseconds: number;

    get watchTime(): TimeSpan {
        return TimeSpan.fromMilliseconds(this._watchTimeMilliseconds);
    }

    @action.bound
    updateWatchTime(): void {
        if (this._watchStartTime) {
            const currentTime = Date.now();
            this._watchTimeMilliseconds += (currentTime - this._watchStartTime);
            this._watchStartTime = currentTime;
        }
    }

    onPlayStarted(): void {
        this._watchStartTime = Date.now();
    }

    onPlayStopped(): void {
        this.updateWatchTime();
        this._watchStartTime = 0;
    }

}